export default __webpack_public_path__ + "static/media/TeamNation.3f7e841f.svg";